import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/core';

// apicore
import { APICore, setAuthorization } from 'src/helpers/api/apiCore';

// api
import {
    creatPatient as createPatientApi,
    updatePatient as updatePatientApi,
    getAllPatient as getAllPatientApi,
    getPatient as getPatientApi,
    getValidatePatient as getValidatePatientApi,
} from './api';

// actions
import { patientApiResponseSuccess, patientApiResponseError } from './actions';

// constants
import { PatientActionTypes } from './constants';

type PatientData = {
    payload: any;
    type: string;
};

const api = new APICore();

/**
 * Add Patient
 * @param {*} payload
 */
function* AddPatient({ payload, type }: PatientData): SagaIterator {
    try {
        const response = yield call(createPatientApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                patientApiResponseSuccess(
                    PatientActionTypes.ADD_PATIENT,
                    data,
                    'Patient has been created.',
                    code,
                    false,
                    true
                )
            );
        } else {
            let msg = `An error while creating Patient!`;
            if (message) msg = message;
            yield put(patientApiResponseSuccess(PatientActionTypes.ADD_PATIENT, data, msg, code, true, false));
        }
    } catch (error: any) {
        yield put(patientApiResponseError(PatientActionTypes.ADD_PATIENT, [], error, 404, true, false));
    }
}

/**
 * Edit Patient
 * @param {*} payload
 */
function* EditPatient({ payload, type }: PatientData): SagaIterator {
    try {
        const response = yield call(updatePatientApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                patientApiResponseSuccess(
                    PatientActionTypes.EDIT_PATIENT,
                    data,
                    'Patient Get Updated Successfully',
                    code,
                    false,
                    true
                )
            );
        } else {
            let msg = `An error while edit Patient!`;
            if (message) msg = message;
            yield put(patientApiResponseSuccess(PatientActionTypes.EDIT_PATIENT, data, msg, code, true, false));
        }
    } catch (error: any) {
        yield put(patientApiResponseError(PatientActionTypes.EDIT_PATIENT, [], error, 404, true, false));
    }
}

/**
 * Fetch Patient
 * @param {*} payload
 */
function* GetPatient({ payload, type }: PatientData): SagaIterator {
    try {
        const response = yield call(getPatientApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(patientApiResponseSuccess(PatientActionTypes.GET_PATIENT, data, message, code, false, false));
        } else {
            let msg = `An error while getting Patient!`;
            if (message) msg = message;
            yield put(patientApiResponseSuccess(PatientActionTypes.GET_PATIENT, data, msg, code, true, false));
        }
    } catch (error: any) {
        yield put(patientApiResponseError(PatientActionTypes.GET_PATIENT, [], error, 404, true, false));
    }
}

/**
 * Fetch Patients
 * @param {*} payload
 */
function* GetPatients({ payload, type }: PatientData): SagaIterator {
    try {
        const response = yield call(getAllPatientApi, payload);
        const { data, message, success, code } = response.data;

        const responseData = typeof data === 'object' && Object.keys(data).length === 0 ? [] : data;
        if (code === 200 && success) {
            yield put(
                patientApiResponseSuccess(PatientActionTypes.GET_PATIENTS, responseData, message, code, false, false)
            );
        } else {
            let msg = `An error while getting Patient Listing!`;
            if (message) msg = message;
            yield put(patientApiResponseSuccess(PatientActionTypes.GET_PATIENTS, responseData, msg, code, true, false));
        }
    } catch (error: any) {
        yield put(patientApiResponseError(PatientActionTypes.GET_PATIENTS, [], error, 404, true, false));
    }
}

/**
 * Fetch Validate Patient
 * @param {*} payload
 */
function* GetValidatePatient({ payload, type }: PatientData): SagaIterator {
    try {
        const response = yield call(getValidatePatientApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                patientApiResponseSuccess(PatientActionTypes.GET_VALIDATE_PATIENT, data, message, code, false, false)
            );
        } else {
            let msg = `An error while getting Patient!`;
            if (message) msg = message;
            yield put(patientApiResponseSuccess(PatientActionTypes.GET_VALIDATE_PATIENT, data, msg, code, true, false));
        }
    } catch (error: any) {
        yield put(patientApiResponseError(PatientActionTypes.GET_VALIDATE_PATIENT, [], error, 404, true, false));
    }
}

export function* watchGetPatient() {
    yield takeEvery(PatientActionTypes.GET_PATIENT, GetPatient);
}

export function* watchGetPatients() {
    yield takeEvery(PatientActionTypes.GET_PATIENTS, GetPatients);
}

export function* watchAddPatient() {
    yield takeEvery(PatientActionTypes.ADD_PATIENT, AddPatient);
}

export function* watchEditPatient(): any {
    yield takeEvery(PatientActionTypes.EDIT_PATIENT, EditPatient);
}

export function* watchGetValidatePatient(): any {
    yield takeEvery(PatientActionTypes.GET_VALIDATE_PATIENT, GetValidatePatient);
}

function* patientSaga() {
    yield all([
        fork(watchGetPatient),
        fork(watchAddPatient),
        fork(watchEditPatient),
        fork(watchGetPatients),
        fork(watchGetValidatePatient),
    ]);
}

export default patientSaga;
